import {
  Content,
  ContentMetadata,
  ContentNode,
  ContentNodeType,
  ContentType,
  ContentTypeMetadata,
} from '@amzn/awscat-pattern-library-service-model';
import React, { useEffect, useState } from 'react';
import PostEditingViewer from './PostEditingViewer';
import { APGLEntityEntry } from '@amzn/awscat-editor/dist/extensions/apgl-entity';
import { loadEntities } from '../../utils/EntitiesUtils';
import LoadingPage from '../../common/LoadingPage';
import { fetchImageInBase64Format } from '../../../editor/utils';
import { MplServiceClientFactory } from '../../../api/MplServiceClientFactory';
import { IMplServiceClient } from '../../../api/IMplServiceClient';

const CreatePostPage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [entities, setEntities] = useState<{ [key: string]: APGLEntityEntry }>();

  const mplServiceClient: IMplServiceClient = MplServiceClientFactory.create();

  useEffect(() => {
    async function loadAllEntities() {
      try {
        const entityPaylod = await loadEntities();
        setEntities(entityPaylod);
      } finally {
        setIsLoading(false); // in case we cannot load entities, we still want to enable creating post
      }
    }
    loadAllEntities();
  }, []);

  const fetchImage = async (srcUrl: string) => {
    return await fetchImageInBase64Format(srcUrl, mplServiceClient);
  };

  const contentMetadata = ContentMetadata.create('', ContentType.Post, '');
  const contentTypeMetadata = ContentTypeMetadata.create('', 1, '');
  const initialSection = ContentNode.create('Summary', '', ContentNodeType.Section, '');
  const contentSections = [initialSection];
  const contentData = ContentNode.create('', '', ContentNodeType.Document, '', [], contentSections);
  const postContent = Content.create(contentMetadata, contentTypeMetadata, {}, contentData);
  return isLoading ? (
    <LoadingPage />
  ) : (
    <PostEditingViewer
      header="Create Post"
      post={postContent}
      // @ts-expect-error TS2322 - strict migration
      audience={null}
      fetchImage={fetchImage}
    />
  );
};

export default CreatePostPage;
